import classNames from "classnames"

import { useTranslation } from "@bounce/i18n"

import { PoiSlider } from "../../../../components/LuggageStorage/PoiSlider/PoiSlider"
import { useSectionViewed } from "../../../../hooks/useSectionViewed"
import type { CityScreenProps } from "../CityScreen"
import type { Interpolations } from "../hooks/useInterpolations"
import InteractiveMap from "@/components/LuggageStorage/Map/Interactive/InteractiveMap"
import StaticCityMap from "@/components/LuggageStorage/Map/Static/StaticCityMap"
import { useInteractiveMapFlag } from "@/hooks/useInteractiveMapFlag"

type MapSectionProps = {
  city: CityScreenProps["city"]
  className?: string
  interpolations: Interpolations
  nearestStores: CityScreenProps["nearestMapStorePins"]
  searchUrl: string
}

export const MapSection = ({ city, className, interpolations, nearestStores, searchUrl }: MapSectionProps) => {
  const { t } = useTranslation("marketing-ls-city")
  const { sectionRef } = useSectionViewed({ name: "MapSection" })
  const { isInteractiveMapEnabled, handleGetStoreUrl } = useInteractiveMapFlag({ city })

  return (
    <div ref={sectionRef} className={classNames("mx-auto flex w-full max-w-screen-xl flex-col px-6", className)}>
      <h2 className="title2 mb-8 break-words md:max-w-none">
        {t("cmp.cityMap.titleV3", "Luggage storage near {{CITY_NAME}} attractions", interpolations)}
      </h2>
      {isInteractiveMapEnabled ? (
        <InteractiveMap city={city} nearestStores={nearestStores} getStoreUrl={handleGetStoreUrl} />
      ) : (
        <StaticCityMap city={city} nearestStores={nearestStores} searchUrl={searchUrl} />
      )}
      <PoiSlider pois={city.pois} limit={6} />
    </div>
  )
}
